import { useEffect, useState } from "react";
import type { InsufficientCredits } from "shared/api/creditDenial";
import { creditDenialEvents } from "shared/api/creditDenial";

/** The latest 402 from any request, until the prompt is dismissed. */
export const useCreditDenial = (): { denial: InsufficientCredits | null; dismiss: () => void } => {
  const [denial, setDenial] = useState<InsufficientCredits | null>(null);

  useEffect(() => creditDenialEvents.subscribe(setDenial), []);

  return { denial, dismiss: () => setDenial(null) };
};
